import type React from "react";
import { ReactComponent as Svg } from "./assets/add-bet.svg";
import * as styles from "./Icon.module.scss";

type AddBetProps = React.SVGProps<SVGSVGElement>;

export const AddBet = ({ className, ...props }: AddBetProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
